import { MediaAssetType } from "mediaModules/media/models/MediaAssetType";

export class MediaMetadataPayload {
  title: string;
  mediaInfoId: string;
  mediaType: MediaAssetType;
  visible: boolean;
  durationInMs?: number;
}
